export class Modal {
  constructor() {
    const btnOpen = document.querySelector('.js-modal-lightbox')
    const modal = document.querySelector('.modal-lightbox')
    const btnClose = document.querySelector('.modal-lightbox_close')

    if (btnOpen) {
      btnOpen.addEventListener('click', function () {
        btnOpen.classList.add('open')
        modal.classList.add('open')
      })

      btnClose.addEventListener('click', function () {
        modal.classList.remove('open')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./js/util/modal.js